enum OwnerAddressFormat {
  Default = '--',
  Base64 = 'Base64',
  DnsOrBase64 = 'DnsOrBase64',
  Name = 'Name',
  Raw = 'Raw',
}

export default OwnerAddressFormat;
